export default {
  files(state) {
    return state.files;
  },
  sumItemsPercentage(state) {
    return state.fileItems.reduce((sum, cur) => {
      if (cur.status === "removed") return sum;
      return (sum += Number(cur.percentage));
    }, 0);
  },
};
